import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function logoutFormatter() {
  window.TrackingHelper?.clearContext('user_data');
  return getGTMEventData(EVENT_NAMES.LOGOUT,
    'success',
    { isLoggedIn: false });
}

export default logoutFormatter;
